import React from 'react'
import {StyledItem, StyledWrapper} from './style'

export type FilterItem = {
    icon?: React.ReactNode
    label: string
    id?: number | string
    key_name?: string
}

export const SelectedFiltersList = ({
    allSelectedFilters,
    bottomPadding,
    isHostFeed = false
}: {
    allSelectedFilters: FilterItem[]
    bottomPadding?: string
    isHostFeed?: boolean
}) => {
    return (
        <StyledWrapper $bottomPadding={bottomPadding} isHostFeed={isHostFeed}>
            {allSelectedFilters?.map((filter, idx, arr) => {
                const uniqueKey = `${filter?.id}-${idx}`
                return (
                    <StyledItem key={uniqueKey}>
                        {filter?.icon}
                        {filter?.label}
                        {idx < arr.length - 1 && ', '}
                    </StyledItem>
                )
            })}
        </StyledWrapper>
    )
}
SelectedFiltersList.displayName = 'SelectedFiltersList'
